export const MAX_HEIGHT = 480;
